<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Merge & Delete Jobsite: ' + jobsite.JobsiteName + ' :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/jobsites`">
                            <i class="fa fa-building"></i> Jobsites
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/jobsites/view/${jobsiteId}`">
                            {{ jobsite.JobsiteName }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">Merge & Delete <i class="fa fa-copy"></i></li>
                </ol>
            </h4>
            <div class="row">
                <div class="col-xl-6 col-lg-8 col-md-7">
                    <div class="card">
                        <div class="card-body">
                            <div class="alert alert-info">
                                You about to merge this jobsite into the selected jobsite below. This will assign all incidents and inspections to the jobsite in the dropdown and then delete this jobsite.
                            </div>

                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.JobsiteName }" class="row">
                                <label class="col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right">Re-assign Jobsite:</label>
                                <div class="col-sm-8">

                                    <jobsite-select v-on:vselected="onJobSiteSelectUpdate" :excludeId="jobsite.JobsiteId"></jobsite-select>

                                    <span v-if="errors.JobsiteName" class="text-danger">
                                        <span v-for="error in errors.JobsiteName">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                        </div>
                        <div class="card-footer">
                            <button type="button" class="btn btn-sm btn-danger" v-on:click="mergeJobsite(this)" :disabled="saving">Merge & Delete Jobsite</button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                jobsiteId: this.$route.params.id,
                jobsite: {},
                errors: {},
                mergeToId: {},
            }
        },

        methods: {
            //Get the Various Resources We Need to Edit a Jobsite
            getErrorClass: function(attribute) {
                return {
                    'form-group has-error': this.errors[attribute],
                    'form-group': !this.errors[attribute],
                }
            },

            getJobsite: function() {
                //Get the data
                this.$http
                    .get('jobsites/merge/' + this.jobsiteId)
                    .then(response => {
                        //Set all the data
                        this.jobsite = response.data;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            mergeJobsite: function() {
                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('jobsites/merge', {JobsiteId: this.jobsiteId, reassign_JobsiteId: this.mergeToId})
                .then(response => {
                    //Create the messgae
                    var deleteMessage = 'Jobsite Merged & Deleted';

                    //Check the return data
                    if(response.data.deleted == false)
                    {
                        deleteMessage = 'This jobsite has been used, so to preserve historical data, it has been marked inactive instead of deleted.';
                    }

                    //Alert the user?
                    this.$toastr.success(deleteMessage);

                    //Return to main list?
                    this.$router.push('/jobsites');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },

            onJobSiteSelectUpdate (selected) {
              this.mergeToId = selected['JobsiteId'];
            }
        },

        mounted() {
            //Get the jobsites
            this.getJobsite();
        }
    }
</script>
